import type { SampleStyleEan } from '../../gql';

import { randNumber } from '@ngneat/falso';

/**
 * Returns a mocked SampleStyleEan. Size defaults to 'M' with no length; pass
 * `size`/`length` overrides to build a size run (see mockSampleStyleOptionData).
 */
const mockSampleStyleEan = (
    overwrite?: Partial<SampleStyleEan>
): SampleStyleEan => ({
    styleEanNumber: randNumber({ min: 27000000, max: 35999999 }),
    size: {
        styleAttributeNumber: String(randNumber({ min: 1000, max: 9999 })),
        styleAttributeName: 'M',
    },
    length: null,
    ...overwrite,
});

export { mockSampleStyleEan };
